import { useEffect, useState } from 'react';
import { getCandidateSubmissionSettingsTemplate, ISubmissionSettingsTemplate } from 'wisestep-api';

const useGetSubmissionSettingsOfJob = (workspaceId: string, templateName: string) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [submissionSettings, setSubmissionSettings] = useState<ISubmissionSettingsTemplate>(
    {} as ISubmissionSettingsTemplate
  );
  useEffect(() => {
    templateName &&
      workspaceId &&
      (async () => {
        try {
          setLoading(true);
          const { data } = await getCandidateSubmissionSettingsTemplate(templateName, workspaceId);
          if (data) {
            setSubmissionSettings(data);
          }
        } catch (e) {
          console.error('Error while getting the submission settings', e);
        } finally {
          setLoading(false);
        }
      })();
  }, [templateName, workspaceId]);

  return { submissionSettings, loading };
};

export default useGetSubmissionSettingsOfJob;
